module.exports = "https://cdn.thelire.com/ins/resource/loading.0e6e0f46d7504242302bc8055ad9c8c2.gif";